import { writable } from "svelte/store"

const createUser = () => {
  const { subscribe, set } = writable(
    JSON.parse(localStorage.getItem("admin-sbi-session")) || null
  )

  return {
    subscribe,
    setUser: (user) => {
      set(user)
      localStorage.setItem("admin-sbi-session", JSON.stringify(user))
    },
  }
}

export const user = createUser()
